import React, { useState, useEffect } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { Dropdown, DropdownButton } from 'react-bootstrap';

import "./assistants.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Utils from "../../utils";
import config from "../../config";
import { PaginationControl } from "react-bootstrap-pagination-control";
import ReadMore from "../../components/ReadMore/ReadMore";
import { t } from "i18next";
import { Assistantlist, deactivateAssistant, duplicateAssistant } from "../../api/assistant.api";
import _ from "lodash";
import NotFoundComponent from "../../components/NotFoundComponent/NotFoundComponent";
import DeleteAssistantModal from "./DeleteAssistantModal";
import CustomPagination from "../../components/common/CustomPagination";

export default function AssistantPage() {
  const limit = 10;
  const [assistants, setAssistants] = useState([]);
  const [uuidData, setUuidData] = useState([]);
  const [uuid, setUuid] = useState("");
  const [page, setPage] = useState(1);
  const [searchOption, setSearchOption] = useState("");
  const [totallength, setTotallength] = useState(0);
  const [totallength2, setTotallength2] = useState(0);
  const [buildBy, setBuildBy] = useState("me");
  const [totalPages, setTotalPages] = useState(0);
  const [isPublished, setIsPublished] = useState(null);
  const [selectedValue, setSelectedValue] = useState("");
  const [selectedFilter, setSelectedFilter] = useState("Filter");
  const [sortBy, setSortBy] = useState("updatedAt");
  const [sortOrder, setSortOrder] = useState("desc");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [showModalDelete, setShowModalDelete] = useState(null);
  const [loading, setLoading] = useState(false);

  const manageRoles = config.fileConfig.MANAGEBLEUSER.split(",")?.map((role) =>
    role.trim()
  );
  const navigate = useNavigate();
  const token = Utils.getLocalStorageItem("_t");
  const fetchData = async () => {
    const payload = {
      buildBy: buildBy, // or 'me' this only required field
      sortBy: sortBy ? sortBy : "updatedAt",
      sortOrder: sortOrder ? sortOrder : "desc",
      // "search":searchOption || "",
      // isPublish: selectedValue,
      // "active": true,
      page: page,
      limit: limit,
      ...(searchOption && { search: searchOption }),
      ...(selectedValue !== "" && { isPublish: selectedValue }),
      ...(buildBy !== "me" && { isPublish: true }),
    };
    try {
      const response = await Assistantlist(payload);
      if (buildBy == "me") {
        setUuidData(response.data?.assistants);
        setTotallength(response.data?.totalCount);
        setTotalPages(response.data?.totalPages);
      } else {
        setAssistants(response.data?.assistants);
        setTotallength2(response.data?.totalCount);
        setTotalPages(response.data?.totalPages);
        if (response.data?.length > 0) {
          setUuid(response.data[0].uuid);
        }
      }
    } catch (error) {
      toast.error("Something went wrong");
    }
  };

  useEffect(() => {
    fetchData();
  }, [token, page, buildBy, searchOption]);
  const fetchDataTable = async (id) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API}/genai/assistantVersion`,
        { uuid: id },
        {
          headers: {
            "X-Access-Token": token,
          },
        }
      );
      if (!_.isEmpty(response)) {
        if (!_.isEmpty(response)) {
          navigate(`/dashboard/mainDashboard/${response.data?.data?.draftUuid}`);
        }
      }
    } catch (error) {
      // toast.error(`${t("somethingWentWrong")}`);
      navigate(`/dashboard/mainDashboard/${id}`);
    }
  };
  const handleEdit = (assistant) => {
    fetchDataTable(assistant);
  };

  // const handleSearch = (e) => {
  //   if (searchOption.length >= 3) {
  //     setPage(1);

  //     fetchData();
  //     setSearching(false);
  //     // setSearchOption("");
  //     setIsSearchDisabled(true);
  //     // Reset page to 1 when performing a new search
  //   }

  //   // Reset page to 1 when performing a new search
  //   // The useEffect hook will automatically fetch data based on updated searchOption and page state
  // };

  // const handleClearSearch = () => {
  //   // setSearchOption(null);
  //   setSearching(true);

  //   fetchData();
  //   setSearchOption(null);
  //   // let temp2 = document.getElementsByClassName("random")?.[0]?.value
  //   // fetchData();
  // };
  const handleSortSelect = (e) => {
    //  console.log("handleSelect",e.target.value)
    // console.log("sortBy:", sortBy, "sortOrder:", sortOrder);
    fetchData();
    setIsDropdownOpen(false);
  };
  const handleToggle = (isOpen) => {
    setIsDropdownOpen(isOpen); // Control dropdown visibility using state
  };

 
  useEffect(() => {
    setIsPublished(() => selectedValue);

    fetchData();
  }, [selectedValue]);

  const handleSelect = (e) => {
    let event = e.target.value;
    if (event === "published") {
      setSelectedValue(true);
      setSelectedFilter("Published");
    } else if (event === "unpublished") {
      setSelectedValue(false);
      setSelectedFilter("Unpublished");
    } else if (event === "Reset") {
      setSelectedValue("");
      setSelectedFilter("Filter");
    }
  };

  const handleTabChange = (e) => {
    if (e === "Builtbyothers") {
      setBuildBy("others");
      setPage(1);
    } else {
      setBuildBy("me");
      setPage(1);
    }
  };
  const handlePreviousPage = () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };
  const handleNextPage = (len) => {
    if (page < len) {
      setPage(page + 1);
    }
  };
  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    const dateOptions = { day: "numeric", month: "long", year: "numeric" };
    const timeOptions = { hour: "2-digit", minute: "2-digit" };
    const formattedDate = date.toLocaleDateString("en-US", dateOptions);
    const formattedTime = date.toLocaleTimeString([], timeOptions);

    return `${formattedDate} ${formattedTime}`;
  };

  const capitalizeFirstLetter = (string) => {
    return string.replace(/\b\w/g, (char) => char.toUpperCase());
  };
  
  const handleCloseDelete = () => setShowModalDelete(null);

  const onClickDeletehandler = async () => {
    setLoading(true);
    try {
        await deactivateAssistant({ assistantId: showModalDelete });
        toast.success(t("deleteAssistantSuccess"));
        setShowModalDelete(null);
        fetchData();
        handleCloseDelete();
    } catch (error) {
      console.log(error);
      toast.error(`${t("somethingWentWrong")}`);
    } finally {
      setLoading(false);
    }
  };

  const duplicate = async (assistantId) => {
    try {
      const response = await duplicateAssistant({ assistantId })
      console.log(response.data);
      
        if (!_.isEmpty(response)) {
          navigate(`/dashboard/mainDashboard/${response.data?.uuid}`);
        }
    } catch (error) {
      // toast.error(`${t("somethingWentWrong")}`);
      navigate(`/dashboard/mainDashboard/${assistantId}`);
    }
  };

  return (
    <>
      <div className="build-assistant-container">
        <div className="title-box-assistant d-flex align-items-center justify-content-between">
          <h1 className="vuild-title mb-0"> {t("assistants")}</h1>

          <button
            type="submit"
            className="builder-btn active btn btn-primary"
            onClick={() => navigate("/dashboard/mainDashboard")}
          >
            {t("buildAssistantbtn")}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M12 5V19M5 12H19"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
        <div className="discritpion-assistant d-flex">
          <div className="discription-img">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="240"
              height="240"
              viewBox="0 0 240 240"
              fill="none"
            >
              <path
                d="M160.675 92.65C163.125 89.975 163.275 85.25 163.4 81.45C163.425 80.675 163.45 79.95 163.475 79.325C163.7 75.975 163.7 72.575 163.7 69.3C163.7 66.075 163.725 62.75 163.925 59.5C164.1 56.7 164.35 52.875 162.25 49.85C159.275 45.525 155.075 45.15 150.65 45.15L92.175 45.125C91.95 45.125 91.7 45.125 91.475 45.125C88.65 45.1 85.45 45.1 82.9 47.05C79.625 49.575 78.325 58.45 78.45 77.725C78.45 78.475 78.45 79.125 78.45 79.625C78.45 79.975 78.45 80.4 78.425 80.825C78.35 84.5 78.25 90.05 81.275 93.2C83.825 95.875 91.575 96.175 94.95 96.175C95.275 96.175 95.55 96.175 95.775 96.175C103.725 96.05 111.225 96.05 118.45 96.05C128.75 96.05 138.475 96.05 147.95 95.675C148.95 95.625 149.875 95.625 150.75 95.6C155 95.525 158.1 95.45 160.675 92.65ZM147.8 91.925C138.4 92.275 128.7 92.275 118.425 92.3C111.175 92.3 103.65 92.3 95.675 92.425C90.25 92.5 84.975 91.7 83.95 90.6C82 88.55 82.1 83.75 82.15 80.875C82.15 80.4 82.175 79.975 82.175 79.6C82.175 79.1 82.175 78.45 82.175 77.675C82.15 73.85 82.125 67.45 82.575 61.55C83.3 51.9 84.875 50.225 85.175 50C86.525 48.95 88.6 48.85 90.675 48.85C90.925 48.85 91.175 48.85 91.425 48.85C91.675 48.85 91.925 48.85 92.15 48.85L150.625 48.875C154.975 48.875 157.35 49.325 159.125 51.95C160.375 53.775 160.325 56.35 160.15 59.25C159.925 62.6 159.925 66 159.925 69.275C159.925 72.5 159.9 75.825 159.7 79.075C159.65 79.775 159.625 80.525 159.6 81.325C159.5 84.35 159.375 88.475 157.875 90.1C156.45 91.65 154.725 91.75 150.625 91.825C149.8 91.85 148.85 91.875 147.8 91.925ZM130.425 78.875C129.55 81.675 127.675 84.075 125.3 85.45C123.775 86.325 122.05 86.775 120.35 86.775C119.1 86.775 117.875 86.525 116.75 86.05C113.85 84.775 111.85 81.875 111.75 78.85C111.725 77.825 112.55 76.95 113.575 76.925C114.6 76.9 115.475 77.725 115.5 78.75C115.55 80.35 116.675 81.925 118.25 82.625C119.825 83.3 121.8 83.15 123.4 82.225C124.975 81.325 126.2 79.7 126.825 77.775C127.125 76.775 128.2 76.25 129.175 76.55C130.2 76.85 130.75 77.9 130.425 78.875ZM107.925 63.35C108.075 64.025 107.825 64.725 107.275 65.175L99.25 71.8C98.9 72.1 98.475 72.225 98.05 72.225C97.5 72.225 96.975 72 96.6 71.55C95.95 70.75 96.05 69.575 96.85 68.9L102.15 64.525L96 62.75C95 62.45 94.425 61.425 94.725 60.425C95.025 59.425 96.05 58.85 97.05 59.15L106.625 61.925C107.275 62.125 107.8 62.675 107.925 63.35ZM146.925 59.8C147.25 60.775 146.7 61.85 145.725 62.175L138.825 64.425L143.875 68.425C144.7 69.075 144.825 70.25 144.175 71.05C143.8 71.525 143.25 71.775 142.7 71.775C142.3 71.775 141.875 71.65 141.55 71.375L133.725 65.2C133.175 64.775 132.925 64.075 133.05 63.4C133.175 62.725 133.65 62.15 134.325 61.95L144.575 58.625C145.55 58.275 146.6 58.825 146.925 59.8ZM89.175 121.225C89.075 119.55 88.95 117.65 88.1 115.875C87.025 113.575 84.925 112.125 82.75 112.225C80.75 112.3 78.275 113.9 77.525 117.175C77.025 119.4 77.525 134.775 78.025 139.7C78.2 141.325 78.45 143.025 79.275 144.575C80.35 146.575 82.225 147.85 84.15 147.9C84.2 147.9 84.25 147.9 84.275 147.9C86.6 147.9 88.85 146.125 89.75 143.525C90.475 141.45 90.325 139.25 90.2 137.475L89.175 121.225ZM86.25 142.3C85.875 143.375 85.025 144.2 84.3 144.15C83.725 144.125 83.025 143.575 82.6 142.8C82.1 141.9 81.9 140.75 81.775 139.325C81.2 133.7 80.9 119.65 81.2 118C81.45 116.925 82.225 116 82.925 115.975C83.525 115.95 84.3 116.6 84.725 117.475C85.25 118.6 85.35 120.075 85.45 121.475L86.525 137.7C86.6 139.3 86.725 140.95 86.25 142.3ZM103.45 115.375C102.55 113.85 101.1 112.75 99.575 112.4C98.375 112.125 97.15 112.325 96.15 113C94.925 113.8 94.05 115.275 93.7 117.075C93.425 118.475 93.45 119.875 93.5 121.125C93.55 122.45 93.525 123.65 93.525 124.8C93.525 126.875 93.5 128.825 93.725 131.2C93.8 132.025 93.85 133.025 93.875 134.05C94 137.15 94.15 140.675 95.275 143.175C96.25 145.3 98.075 146.625 99.95 146.625C100.225 146.625 100.475 146.6 100.75 146.55C102.325 146.225 103.7 144.875 104.425 142.975C104.95 141.575 105.1 140.1 105.175 138.7C105.55 133.25 105.525 127.7 105.125 122.25C104.975 120.05 104.7 117.5 103.45 115.375ZM101.475 138.5C101.4 139.675 101.3 140.8 100.95 141.7C100.65 142.475 100.225 142.875 100 142.925C99.775 142.975 99.125 142.575 98.725 141.675C97.9 139.825 97.775 136.7 97.65 133.95C97.6 132.85 97.575 131.825 97.475 130.9C97.275 128.7 97.275 126.825 97.3 124.85C97.3 123.65 97.3 122.425 97.275 121.05C97.25 119.95 97.2 118.825 97.4 117.85C97.55 117.05 97.9 116.375 98.275 116.15C98.35 116.1 98.425 116.05 98.575 116.05C98.625 116.05 98.7 116.05 98.775 116.075C99.3 116.2 99.875 116.675 100.25 117.3C101.075 118.725 101.3 120.675 101.425 122.575C101.8 127.85 101.825 133.2 101.475 138.5ZM119.3 114.7C118.35 112.85 116.65 111.65 114.875 111.575C112.675 111.475 110.55 113.1 109.675 115.525C109.025 117.375 109.15 119.35 109.25 120.925C109.425 123.55 109.525 125.95 109.625 128.25C109.8 132.025 109.95 135.6 110.375 139.9C110.475 140.85 110.9 144.05 112.7 145.45C113.675 146.2 114.85 146.6 116.025 146.6C116.275 146.6 116.525 146.575 116.775 146.55C118.025 146.375 119.075 145.725 119.75 144.75C120.9 143.1 121.15 141.35 121.275 139.7C121.85 132.7 121.225 125.625 120.45 119.05C120.225 117.6 120 116.1 119.3 114.7ZM117.5 139.375C117.375 140.875 117.2 141.775 116.65 142.6C116.525 142.775 116.3 142.825 116.175 142.85C115.775 142.9 115.35 142.775 114.975 142.5C114.7 142.25 114.225 141.025 114.075 139.55C113.675 135.35 113.525 131.85 113.35 128.1C113.25 125.775 113.15 123.375 112.975 120.7C112.875 119.325 112.8 117.925 113.2 116.775C113.475 115.975 114.175 115.3 114.675 115.325C115.1 115.35 115.625 115.8 115.95 116.425C116.375 117.25 116.525 118.325 116.675 119.475C117.425 125.85 118.05 132.7 117.5 139.375ZM136.6 124.225C137.025 124.3 137.45 124.325 137.875 124.325C139.85 124.325 141.775 123.575 143.1 122.2C144.9 120.35 145.475 117.575 144.5 115.275C143.6 113.175 141.825 111.65 139.625 111.15C137.35 110.625 134.9 111.225 133.1 112.775C131.475 114.175 130.575 116.3 130.775 118.325C131.05 121.225 133.5 123.7 136.6 124.225ZM135.55 115.65C136.25 115.05 137.1 114.725 137.975 114.725C138.25 114.725 138.5 114.75 138.775 114.825C139.825 115.075 140.625 115.75 141.05 116.775C141.425 117.65 141.15 118.85 140.425 119.6C139.675 120.375 138.4 120.75 137.225 120.525C135.825 120.275 134.625 119.175 134.5 117.975C134.425 117.175 134.85 116.275 135.55 115.65ZM156.8 123.825C157.05 123.825 157.3 123.8 157.575 123.775C159.575 123.575 161.35 122.6 162.425 121.125C164.075 118.875 163.9 115.525 162.05 113.325C160.275 111.225 157.15 110.125 154.425 110.6C152.225 111 150.525 112.425 149.775 114.475C148.95 116.775 149.5 119.475 151.175 121.35C152.525 122.925 154.65 123.825 156.8 123.825ZM153.25 115.775C153.55 114.95 154.125 114.475 155.05 114.3C156.475 114.05 158.225 114.675 159.15 115.75C159.9 116.625 160 118.05 159.375 118.9C158.925 119.5 158.1 119.925 157.175 120.025C155.95 120.15 154.675 119.675 153.925 118.85C153.175 118.05 152.9 116.775 153.25 115.775ZM139.875 131.2C136.85 130.725 135.175 131.8 133.95 132.925C132.575 134.175 131.7 136.2 131.775 137.925C131.85 139.7 132.625 141.325 134.025 142.625C135.05 143.575 136.5 144.35 137.825 144.675C138.25 144.775 138.7 144.825 139.15 144.825C141.275 144.825 143.425 143.675 144.6 141.825C145.925 139.725 145.95 136.9 144.675 134.675C143.55 132.7 141.9 131.5 139.875 131.2ZM141.4 139.85C140.85 140.75 139.65 141.275 138.7 141.05C138 140.875 137.15 140.4 136.575 139.9C135.9 139.275 135.55 138.575 135.525 137.775C135.5 137.125 135.925 136.2 136.475 135.7C137.075 135.15 137.6 134.85 138.475 134.85C138.725 134.85 138.975 134.875 139.3 134.925C140.175 135.05 140.85 135.6 141.4 136.55C141.975 137.55 141.975 138.925 141.4 139.85ZM158.35 130.025C155.625 129.575 152.975 130.525 151.475 132.5C149.95 134.475 149.675 137.275 150.775 139.6C151.625 141.425 153.3 142.875 155.225 143.475C155.9 143.675 156.6 143.775 157.325 143.775C159.2 143.775 161.025 143.05 162.375 141.75C164.25 139.9 164.925 137.025 164.1 134.575C163.25 132.2 161.075 130.475 158.35 130.025ZM159.7 139.075C158.85 139.9 157.45 140.25 156.3 139.875C155.375 139.6 154.55 138.875 154.15 138C153.65 136.95 153.775 135.625 154.425 134.775C155.05 133.95 156.075 133.65 157 133.65C157.25 133.65 157.5 133.675 157.725 133.7C158.8 133.875 160.075 134.5 160.5 135.75C160.875 136.875 160.55 138.225 159.7 139.075ZM217 36.825C214.95 36.75 213.075 37.475 211.875 38.85C209.7 41.325 210.125 44.675 210.475 47.35L210.5 47.45C210.55 47.75 210.575 48.05 210.625 48.35C210.9 50.325 211.175 52.2 210.35 53.45C209.45 54.825 206.7 56.2 202.775 55.925C200.85 55.8 198.35 54.975 197.6 53.075C197.125 51.85 197.675 50.325 198.325 48.55C199.1 46.45 199.975 44.05 199.125 41.55C198.375 39.3 196.175 37.65 193.825 37.525C191.325 37.375 189.35 39.45 188.325 41.425C186.075 45.875 185.1 50.375 185.525 54.5C186.05 59.525 188.725 63.925 192.65 66.225C192.8 66.325 192.95 66.4 193.1 66.475C193.075 68.975 192.975 71.75 192.65 74.325C192.2 78.1 191.325 80.975 189.95 83.325C189.825 83.525 189.7 83.725 189.575 83.95C187.9 86.55 185.875 88.525 183.55 89.85C181.7 90.9 179.6 91.55 177.3 91.8C177.275 82.025 177.275 72.175 177.35 62.575C177.475 49.1 175.05 39.575 170.15 34.25C164.225 27.8 155.025 25.5 148.325 24.7C134.75 23.075 122.75 22.725 109.4 23.6C102.7 24.025 94.85 24.825 87.5 27.475C81.95 29.475 74.3 33.45 69.4 41C64.375 48.75 63.525 58.025 63.075 67.65C62.7 75.575 62.45 83.925 62.35 92.45C56.175 92.575 49.875 94.2 44.05 97.15H44.025C38.375 100.025 33.225 104.15 29.125 109.05C28 110.375 26.975 111.8 26.075 113.25C26.075 113.25 26.075 113.25 26.075 113.275C22.45 119.1 20.45 126 19.95 134.35C19.725 138.175 19.8 142.4 20.175 147.2C19.95 147.375 19.7 147.575 19.475 147.75C16.3 150.475 14.525 154.9 14.625 159.85C14.7 164.025 15.575 169.5 17.75 172.4C18.9 173.925 20.9 174.9 23.05 174.95C23.15 174.95 23.225 174.95 23.325 174.95C25.275 174.95 27.05 174.2 28.175 172.9C30.35 170.4 29.9 167.075 29.525 164.375L29.5 164.275C29.45 163.975 29.425 163.675 29.375 163.375C29.075 161.4 28.825 159.525 29.625 158.275C30.525 156.9 33.275 155.525 37.175 155.75C39.1 155.875 41.6 156.675 42.375 158.575C42.875 159.8 42.3 161.325 41.675 163.1C40.9 165.225 40.05 167.6 40.9 170.1C41.675 172.325 43.85 173.975 46.225 174.1C48.75 174.225 50.7 172.15 51.7 170.175C53.95 165.725 54.9 161.2 54.45 157.1C53.9 152.075 51.225 147.7 47.3 145.4C47.15 145.3 47 145.225 46.85 145.15C46.875 142.65 46.95 139.875 47.25 137.3C47.7 133.525 48.55 130.65 49.9 128.275C50.025 128.075 50.15 127.875 50.275 127.65C51.95 125.05 53.975 123.05 56.275 121.725C58.125 120.675 60.2 120 62.5 119.75C62.725 130.125 63.125 140.275 63.725 149.75C64 154.225 67.75 157.75 72.275 157.75C72.875 157.75 73.5 157.75 74.1 157.75C69.125 169.675 67.35 183.725 68.55 201.575C64.475 204.95 62.325 209.625 63.025 214.225C63.15 215.125 63.925 215.8 64.85 215.825C71.5 215.95 78.45 215.95 85.2 215.95C91.925 215.95 98.875 215.95 105.475 216.075H105.5C106.45 216.075 107.25 215.35 107.375 214.4C107.85 209.925 105.675 205.4 101.7 202.025C101.425 183.8 101.675 173.85 107.975 157.5C115.675 157.375 123.425 157.225 131.125 156.975C133.3 160.775 134.975 164.475 136.3 168.175C136.325 168.25 136.35 168.325 136.375 168.4C140.1 178.95 140.75 189.55 140.325 202.5C136.425 205.85 134.375 210.425 135.075 214.925C135.2 215.825 135.975 216.5 136.9 216.525C143.55 216.65 150.5 216.65 157.25 216.65C163.975 216.65 170.925 216.65 177.525 216.775H177.55C178.5 216.775 179.3 216.05 179.425 215.1C179.9 210.675 177.75 206.175 173.825 202.8C174.4 187.125 174.1 176.525 169.825 164.275C169.8 164.125 169.75 163.975 169.675 163.825C168.7 161.1 167.525 158.275 166.125 155.275C167.25 155.2 168.35 155.125 169.475 155.05C173.875 154.725 177.35 151 177.4 146.6C177.475 137.575 177.475 128.325 177.475 119.15C183.625 119.025 189.9 117.45 195.725 114.5C195.725 114.5 195.75 114.5 195.75 114.475C201.4 111.625 206.575 107.525 210.7 102.625C211.825 101.3 212.85 99.875 213.75 98.425C213.75 98.425 213.75 98.425 213.75 98.4C217.4 92.575 219.425 85.7 219.975 77.35C220.225 73.525 220.15 69.3 219.8 64.5C220.025 64.325 220.275 64.15 220.5 63.95C223.675 61.225 225.475 56.825 225.4 51.875C225.35 47.7 224.5 42.225 222.325 39.325C221.125 37.875 219.15 36.9 217 36.825ZM28.3 116.9L45.8 128.075C44.85 130.1 44.2 132.375 43.75 135.075C37.1 134.325 30.45 133.55 23.8 132.8C24.375 126.65 25.85 121.425 28.3 116.9ZM23.6 136.575C30.175 137.325 36.75 138.075 43.325 138.825C43.2 140.475 43.125 142.125 43.1 143.725C40.075 142.85 36.575 142.575 32.65 142.925C30.1 143.15 26.85 143.725 23.775 145.125C23.575 142 23.525 139.175 23.6 136.575ZM50.725 157.6C51.1 161 50.275 164.8 48.375 168.6C47.825 169.675 47 170.5 46.45 170.475C45.6 170.425 44.75 169.8 44.475 169C44.05 167.75 44.625 166.175 45.225 164.5C46.025 162.325 46.925 159.85 45.9 157.3C44.5 153.775 40.625 152.325 37.45 152.125C33.825 151.9 28.775 152.875 26.525 156.325C24.925 158.75 25.35 161.55 25.7 164.025C25.75 164.3 25.775 164.6 25.825 164.875L25.85 164.975C26.125 167.1 26.425 169.325 25.375 170.525C24.925 171.025 24.125 171.325 23.2 171.275C22.175 171.25 21.25 170.825 20.775 170.2C19.45 168.45 18.5 164.275 18.4 159.85C18.325 156.075 19.65 152.625 21.95 150.65C22.35 150.3 22.75 150 23.175 149.725C26.25 147.675 30.125 146.925 32.975 146.675C33.975 146.575 34.95 146.55 35.875 146.55C39.1 146.55 41.875 147.075 44.2 148.15C44.2 148.15 44.225 148.15 44.225 148.175C44.625 148.375 45.025 148.575 45.4 148.775C48.275 150.4 50.3 153.8 50.725 157.6ZM47.7 124.85L30.275 113.725C30.825 112.95 31.4 112.2 32 111.475C35.375 107.45 39.5 104 44.05 101.4C46.4 106.2 48.75 111.025 51.1 115.825L52.9 119.525C50.975 120.9 49.225 122.675 47.7 124.85ZM56.175 117.675L54.475 114.175C52.125 109.35 49.75 104.525 47.4 99.7C52.225 97.5 57.325 96.3 62.325 96.175C62.275 102.8 62.3 109.475 62.4 116.1C60.2 116.3 58.1 116.825 56.175 117.675ZM75.05 166.375C83.525 166.675 92.025 167.525 100.375 168.925C99.15 173.875 98.5 178.55 98.15 183.5C89.475 183.2 80.75 183.475 72.125 184.325C72.525 177.75 73.5 171.825 75.05 166.375ZM71.975 188.1C80.575 187.25 89.325 186.95 97.975 187.25C97.825 191.025 97.825 195.05 97.9 199.575C97.4 199.325 96.9 199.075 96.4 198.85C89.475 195.775 80.225 195.725 73.425 198.725C73 198.9 72.575 199.1 72.175 199.325C71.95 195.375 71.875 191.65 71.975 188.1ZM103.625 212.4C98.7 212.325 93.625 212.325 88.625 212.325C87.475 212.325 86.325 212.325 85.175 212.325C79.05 212.325 72.725 212.325 66.65 212.25C66.8 209.275 68.575 206.35 71.5 204.15C71.55 204.1 71.625 204.075 71.675 204.025C72.65 203.325 73.725 202.7 74.925 202.175C80.825 199.575 88.85 199.625 94.875 202.3C96.25 202.9 97.5 203.65 98.6 204.475C98.675 204.525 98.725 204.575 98.8 204.625C101.55 206.775 103.325 209.575 103.625 212.4ZM101.375 165.275C93.1 163.875 84.65 163 76.25 162.65C76.825 161 77.475 159.4 78.175 157.825C86.65 157.8 95.275 157.75 103.925 157.65C102.925 160.35 102.075 162.875 101.375 165.275ZM139.375 165.75C138.275 162.85 136.925 159.925 135.325 156.95C144.325 156.625 153.275 156.225 162.075 155.65C163.35 158.275 164.425 160.75 165.35 163.125L139.375 165.75ZM170.85 205.3C173.625 207.475 175.375 210.25 175.675 213.075C170.75 213 165.675 213 160.675 213C159.525 213 158.375 213 157.225 213C151.1 213 144.775 213 138.7 212.925C138.85 210.05 140.5 207.225 143.25 205.075C143.3 205.05 143.35 205 143.4 204.95C144.45 204.15 145.65 203.425 146.975 202.85C152.875 200.25 160.9 200.3 166.925 202.975C168.3 203.575 169.55 204.325 170.675 205.175C170.7 205.2 170.775 205.25 170.85 205.3ZM170.15 200.375C169.6 200.075 169.025 199.8 168.425 199.525C161.5 196.45 152.25 196.4 145.45 199.4C145 199.6 144.575 199.8 144.15 200.025C144.25 195.75 144.2 191.7 143.925 187.825C152.675 187.425 161.5 187.65 170.225 188.45C170.325 192.1 170.275 196.025 170.15 200.375ZM166.675 166.775C168.675 172.8 169.65 178.425 170.05 184.675C161.275 183.9 152.4 183.7 143.625 184.1C143.1 179.05 142.15 174.2 140.65 169.4L166.675 166.775ZM173.6 146.65C173.575 149.125 171.625 151.225 169.15 151.4C157.05 152.3 144.625 152.9 132.125 153.3C132.1 153.3 132.1 153.3 132.075 153.3C112.025 153.95 91.75 154.075 72.25 154.1C69.725 154.1 67.625 152.125 67.45 149.6C65.825 124.2 65.6 93.625 66.85 67.8C67.3 58.7 68.05 49.975 72.575 43.025C76.9 36.35 83.8 32.8 88.825 31C95.75 28.5 103.25 27.75 109.675 27.325C114.3 27.025 118.775 26.875 123.2 26.875C131.325 26.875 139.3 27.375 147.925 28.425C154 29.15 162.3 31.2 167.45 36.8C171.675 41.4 173.775 50.075 173.65 62.55C173.525 76.4 173.575 90.75 173.625 104.65C173.65 108.75 173.65 112.9 173.675 117.075C173.65 117.15 173.65 117.25 173.65 117.325C173.65 117.45 173.65 117.6 173.675 117.725C173.7 127.375 173.7 137.15 173.6 146.65ZM177.425 115.475C177.425 111.825 177.4 108.2 177.4 104.6C177.4 101.6 177.375 98.575 177.375 95.55C179.625 95.35 181.725 94.825 183.675 94L185.525 97.825C187.8 102.55 190.1 107.3 192.4 112.025C187.525 114.2 182.425 115.375 177.425 115.475ZM207.8 100.3C204.4 104.325 200.25 107.75 195.7 110.325C193.425 105.625 191.15 100.9 188.875 96.175L186.925 92.15C188.875 90.775 190.625 89 192.15 86.85L209.525 98.05C208.975 98.825 208.4 99.575 207.8 100.3ZM211.525 94.875L194.05 83.625C195 81.6 195.675 79.325 196.125 76.625C202.775 77.4 209.425 78.2 216.075 78.975C215.5 85.15 214 90.375 211.525 94.875ZM216.3 75.25C209.725 74.475 203.15 73.7 196.575 72.925C196.725 71.275 196.775 69.625 196.825 68.025C199.025 68.675 201.5 69 204.2 69C205.2 69 206.225 68.95 207.275 68.875C209.825 68.65 213.075 68.1 216.15 66.725C216.35 69.8 216.4 72.625 216.3 75.25ZM218.025 61.2C217.625 61.525 217.225 61.85 216.775 62.125C213.7 64.15 209.825 64.9 206.95 65.125C202.5 65.5 198.775 65 195.8 63.65C195.775 63.625 195.725 63.625 195.7 63.6C195.3 63.4 194.9 63.2 194.55 63C191.7 61.325 189.675 57.9 189.25 54.1C188.9 50.7 189.725 46.925 191.65 43.125C192.2 42.05 193.05 41.225 193.6 41.275C194.45 41.325 195.3 41.975 195.575 42.775C196 44.025 195.425 45.6 194.8 47.275C194 49.45 193.1 51.925 194.1 54.475C195.5 58 199.35 59.475 202.525 59.675C206.15 59.925 211.2 58.975 213.475 55.525C215.075 53.1 214.675 50.3 214.325 47.825C214.275 47.55 214.25 47.25 214.2 46.975L214.175 46.875C213.9 44.75 213.6 42.525 214.675 41.325C215.125 40.825 215.925 40.525 216.85 40.575C217.875 40.625 218.8 41.025 219.275 41.675C220.6 43.45 221.55 47.6 221.6 52.025C221.675 55.8 220.325 59.225 218.025 61.2Z"
                fill="black"
              />
            </svg>
          </div>
          <div className="assitant-info-head">
            <p>
              {/* {t("buliltByMeTabPara1")} */}
              <ReadMore text={t("buliltByMeTabPara1")} charLimit={300} />
            </p>
            {/* <div className="btn-wrapper">
                  <button type="submit" className="builder-btn btn btn-primary">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_394_17596)">
                        <path
                          d="M7.57496 7.5C7.77088 6.94306 8.15759 6.47342 8.66659 6.17428C9.17559 5.87513 9.77404 5.76578 10.3559 5.86559C10.9378 5.96541 11.4656 6.26794 11.8459 6.71961C12.2261 7.17128 12.4342 7.74294 12.4333 8.33333C12.4333 10 9.93329 10.8333 9.93329 10.8333M9.99996 14.1667H10.0083M18.3333 10C18.3333 14.6024 14.6023 18.3333 9.99996 18.3333C5.39759 18.3333 1.66663 14.6024 1.66663 10C1.66663 5.39763 5.39759 1.66667 9.99996 1.66667C14.6023 1.66667 18.3333 5.39763 18.3333 10Z"
                          stroke="#0061AF"
                          stroke-width="1.66667"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_394_17596">
                          <rect width="20" height="20" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    {t("knowMore")}
                  </button>
                  <button type="submit" className="builder-btn btn btn-primary">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_394_17600)">
                        <path
                          d="M10.0001 18.3333C14.6025 18.3333 18.3334 14.6024 18.3334 10C18.3334 5.39763 14.6025 1.66667 10.0001 1.66667C5.39771 1.66667 1.66675 5.39763 1.66675 10C1.66675 14.6024 5.39771 18.3333 10.0001 18.3333Z"
                          stroke="#0061AF"
                          stroke-width="1.66667"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M7.91675 7.47111C7.91675 7.07337 7.91675 6.87451 7.99987 6.76348C8.0723 6.66673 8.18318 6.6062 8.30373 6.59759C8.44207 6.58771 8.60935 6.69525 8.94392 6.91033L12.8777 9.43922C13.1681 9.62585 13.3132 9.71917 13.3634 9.83783C13.4072 9.94151 13.4072 10.0585 13.3634 10.1622C13.3132 10.2808 13.1681 10.3742 12.8777 10.5608L8.94392 13.0897C8.60935 13.3048 8.44207 13.4123 8.30373 13.4024C8.18318 13.3938 8.0723 13.3333 7.99987 13.2365C7.91675 13.1255 7.91675 12.9266 7.91675 12.5289V7.47111Z"
                          stroke="#0061AF"
                          stroke-width="1.66667"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_394_17600">
                          <rect width="20" height="20" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>{" "}
                    {t("takeATour")}
                  </button>
                </div>  */}
          </div>
        </div>
        <div className="filter-assitant">
          <div className="input-wrap-row-wrap">
            <div className="form-input-wrapper search-filter d-flex align-items-center gap-2s">
              <input
                value={searchOption}
                className="form-control random"
                onChange={(event) => {
                  setSearchOption(event.target.value);
                  setPage(1);
                }}
                placeholder="Search"
                maxLength={322}
              />

              <button className="search-cion" type="button" id="button-addon2">
                {searchOption == "" ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                    fill="rgba(0,0,0,1)"
                  // onClick={()=>setSearchOption("")}
                  >
                    <path d="M11 2C15.968 2 20 6.032 20 11C20 15.968 15.968 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2ZM11 18C14.8675 18 18 14.8675 18 11C18 7.1325 14.8675 4 11 4C7.1325 4 4 7.1325 4 11C4 14.8675 7.1325 18 11 18ZM19.4853 18.0711L22.3137 20.8995L20.8995 22.3137L18.0711 19.4853L19.4853 18.0711Z"></path>
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                    fill="rgba(0,0,0,1)"
                    onClick={() => setSearchOption("")}
                  >
                    <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 10.5858L14.8284 7.75736L16.2426 9.17157L13.4142 12L16.2426 14.8284L14.8284 16.2426L12 13.4142L9.17157 16.2426L7.75736 14.8284L10.5858 12L7.75736 9.17157L9.17157 7.75736L12 10.5858Z"></path>
                  </svg>
                )}
              </button>
            </div>
            {/* {buildBy==="me" &&<div className="form-input-wrapper">
                  <Dropdown onSelect={handleSelect}>
                    <Dropdown.Toggle
                      style={{
                        color: "red",
                        border: "1px solid black",
                        backgroundColor: "black",
                      }}
                      variant="success"
                      id="dropdown-success"
                    >
                       {selectedFilter}
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item eventKey="published" >
                        Published
                      </Dropdown.Item>
                      <Dropdown.Item eventKey="unpublished">
                        Unpublished
                      </Dropdown.Item>
                      <Dropdown.Item eventKey="Reset">
                       Reset
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>} */}
          </div>
        </div>

        <Tabs
          onSelect={handleTabChange}
          defaultActiveKey="Builtbyme"
          transition={false}
          id="noanim-tab-example"
          className="mt-5 custom-tab-section"
        >
          <Tab
            onClick={() => {
              setBuildBy("me");
            }}
            eventKey="Builtbyme"
            title={t("builtByMe")}
          >
            <div className="filter-drop">
              <select
                onChange={handleSelect}
                className="form-select"
                aria-label="Default select example"
              >
                <option eventKey="Reset" value="Reset">
                  {t("published")} + {t("drafts")}
                </option>
                <option eventKey="published" value="published">
                  {t("published")}
                </option>
                <option eventKey="unpublished" value="unpublished">
                  {t("drafts")}
                </option>
              </select>
             <DropdownButton
                    align="end"
                    title="Sort By"
                    id="dropdown-menu-align-end"
                    className="custom-dropdown"
                    show={isDropdownOpen}
                    onToggle={handleToggle}
                  >
                    <div className="sortoption" onClick={(e) => e.stopPropagation()}>
                      <div className="d-flex justify-content-end align-items-center">
                        {/* <div className="sorthead">Sort By</div> */}
                        <div className="close cursor-pointer">
                            <svg
                              onClick={()=>setIsDropdownOpen(false)}
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width="24"
                              height="24"
                              fill="rgba(0,0,0,1)"
                            >
                              <path d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z"></path>
                            </svg>
                          </div>
                      </div>
                      <div className="sort-options">
                        <div className="d-flex gap-3 align-items-center">
                          <select
                            onChange={(event)=>setSortBy(event.target.value)}
                            className="form-select"
                            aria-label="Default select example"
                          >
                           
                            <option  value="updatedAt">
                            Modified Date
                            </option>
                            <option  value="title">
                            Title
                            </option>

                          </select>
                          <select
                            className={`form-select asbtn ${sortOrder === 'desc' ? 'dsc' : 'asc'}`}
                            aria-label="Default select example"
                            onChange={(event)=>setSortOrder(event.target.value)}
                            value={sortOrder}
                          >
                            <option value="asc">Ascending</option>
                            <option value="desc">Descending</option>
                          </select>
                        </div>
                        <div className="btnsec mt-3 d-flex justify-content-end">
                          <button className="default-btn" onClick={handleSortSelect}>Apply</button>
                        </div>
                       
                      </div>
                    </div>
                  </DropdownButton> 
            </div>

            {/* <NotFoundComponent /> */}

            {uuidData?.length <= 0 ? (
              <NotFoundComponent message={t("noAssistantFound")} />
            ) : (
              uuidData?.map(
                (assistant) =>
                  !assistant.isDraft && (
                    <div className="pdf-wrapper">
                      <div className="pdf-list-assitant" key={assistant._id}>
                        <div className="pdf-icon-box">
                          {assistant.thumbnailUrl &&
                            typeof assistant.thumbnailUrl === "string" ? (
                            <img
                              style={{
                                width: "56px",
                                height: "56px",
                                borderRadius: "100%",
                              }}
                              src={assistant.thumbnailUrl}
                              alt=""
                            />
                          ) : (
                            <svg
                              width="56"
                              height="56"
                              viewBox="0 0 56 56"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect
                                width="56"
                                height="56"
                                rx="28"
                                fill="#F2F4F7"
                              />
                              <g opacity="0.08">
                                <rect
                                  x="0.375"
                                  y="0.375"
                                  width="55.25"
                                  height="55.25"
                                  rx="27.625"
                                  stroke="#101828"
                                  strokeWidth="0.75"
                                />
                              </g>
                              <path
                                d="M30.6667 15.026V20.5334C30.6667 21.2802 30.6667 21.6535 30.812 21.9388C30.9399 22.1896 31.1438 22.3936 31.3947 22.5214C31.6799 22.6668 32.0533 22.6668 32.8 22.6668H38.3074M30.6667 34.6667H22.6667M33.3334 29.3333H22.6667M38.6667 25.3176V34.9333C38.6667 37.1735 38.6667 38.2937 38.2307 39.1493C37.8472 39.9019 37.2353 40.5139 36.4827 40.8974C35.627 41.3333 34.5069 41.3333 32.2667 41.3333H23.7334C21.4932 41.3333 20.3731 41.3333 19.5174 40.8974C18.7648 40.5139 18.1528 39.9019 17.7693 39.1493C17.3334 38.2937 17.3334 37.1735 17.3334 34.9333V21.0667C17.3334 18.8265 17.3334 17.7064 17.7693 16.8507C18.1528 16.0981 18.7648 15.4861 19.5174 15.1026C20.3731 14.6667 21.4932 14.6667 23.7334 14.6667H28.0157C28.9941 14.6667 29.4833 14.6667 29.9436 14.7772C30.3518 14.8752 30.742 15.0368 31.0998 15.2561C31.5035 15.5035 31.8494 15.8494 32.5412 16.5412L36.7922 20.7922C37.484 21.484 37.8299 21.8299 38.0773 22.2335C38.2966 22.5914 38.4582 22.9816 38.5562 23.3897C38.6667 23.8501 38.6667 24.3393 38.6667 25.3176Z"
                                stroke="#475467"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          )}
                        </div>
                        <div className="pdf-info-box">
                          <div className="d-flex pdf-title-ass">
                            <div className="pdf-name">{assistant.title}</div>
                            <ul className="pills-pdf mb-0">
                              <li className="ed">
                                {assistant.count} {t("users")}
                              </li>
                              {assistant.isPublish ? (
                                <li className="poubli"> {t("published")} </li>
                              ) : (
                                <li className="unpubli">
                                  {" "}
                                  {t("unpublished")}{" "}
                                </li>
                              )}
                              {/* <li className="poubli"> {t("createdOn")}{" "}{assistant.createdAt} </li>
                               <li className="poubli"> {t("modifiedOn")}{" "}{assistant.updatedAt} </li> */}
                              {/* <li className="cop">4 copies</li> */}
                            </ul>
                          </div>
                          {assistant.updatedAt ? (
                            <p className="mb-0  ">
                              {capitalizeFirstLetter(t("modifiedOn"))}
                              {/* <br /> */}{" "}
                              {formatDateTime(assistant.updatedAt)}
                            </p>
                          ) : (
                            <p className="mb-0  ">
                              {capitalizeFirstLetter(t("createdOn"))}
                              {/* <br /> */}{" "}
                              {formatDateTime(assistant.createdAt)}
                            </p>
                          )}
                          <p className="mb-0 assist-desc">
                            {assistant.description}
                          </p>
                        </div>
                        <div className="btn-pdf-wrapper">
                          <button
                            type="submit"
                            className="custom-bt btn-primary"
                            onClick={() => handleEdit(assistant.uuid)}
                          >
                            {t("modify")}
                          </button>
                          {assistant.isPublish && (
                            <button
                              type="submit"
                              className="custom-bt btn-primary"
                              onClick={() =>
                                navigate(`/assignuser?uuid=${assistant?.uuid}`)
                              }
                            >
                              {t("assign")}
                            </button>
                          )}
                          <button
                            type="submit"
                            className="custom-bt btn-primary"
                            onClick={() =>
                              navigate(
                                `/assistant/launch?uuid=${assistant.uuid}`
                              )
                            }
                          >
                            {t("useIt")}{" "}
                          </button>
                          <button
                            type="submit"
                            className="custom-bt btn-primary"
                            onClick={() =>
                              navigate(`/report/${assistant.uuid}`)
                            }
                          >
                            {t("Usage")}
                          </button>
                
                          <Dropdown className="customdropdown-btn">
                                <Dropdown.Toggle
                                  variant="success"
                                  id="dropdown-basic"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                  >
                                    <path
                                      d="M10.0001 10.8333C10.4603 10.8333 10.8334 10.4602 10.8334 9.99999C10.8334 9.53976 10.4603 9.16666 10.0001 9.16666C9.53984 9.16666 9.16675 9.53976 9.16675 9.99999C9.16675 10.4602 9.53984 10.8333 10.0001 10.8333Z"
                                      stroke="#98A2B3"
                                      stroke-width="1.66667"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M10.0001 4.99999C10.4603 4.99999 10.8334 4.6269 10.8334 4.16666C10.8334 3.70642 10.4603 3.33333 10.0001 3.33333C9.53984 3.33333 9.16675 3.70642 9.16675 4.16666C9.16675 4.6269 9.53984 4.99999 10.0001 4.99999Z"
                                      stroke="#98A2B3"
                                      stroke-width="1.66667"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M10.0001 16.6667C10.4603 16.6667 10.8334 16.2936 10.8334 15.8333C10.8334 15.3731 10.4603 15 10.0001 15C9.53984 15 9.16675 15.3731 9.16675 15.8333C9.16675 16.2936 9.53984 16.6667 10.0001 16.6667Z"
                                      stroke="#98A2B3"
                                      stroke-width="1.66667"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                  <div className="list-drop cursor-pointer"
                                  onClick={() => duplicate(assistant.uuid)}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      viewBox="0 0 16 16"
                                      fill="none"
                                    >
                                      <g clip-path="url(#clip0_394_18059)">
                                        <path
                                          d="M5.33325 10.6666V12.5333C5.33325 13.28 5.33325 13.6534 5.47858 13.9386C5.60641 14.1895 5.81038 14.3935 6.06126 14.5213C6.34648 14.6666 6.71985 14.6666 7.46659 14.6666H12.5333C13.28 14.6666 13.6534 14.6666 13.9386 14.5213C14.1895 14.3935 14.3934 14.1895 14.5213 13.9386C14.6666 13.6534 14.6666 13.28 14.6666 12.5333V7.46665C14.6666 6.71991 14.6666 6.34654 14.5213 6.06133C14.3934 5.81044 14.1895 5.60647 13.9386 5.47864C13.6534 5.33331 13.28 5.33331 12.5333 5.33331H10.6666M3.46659 10.6666H8.53325C9.27999 10.6666 9.65336 10.6666 9.93857 10.5213C10.1895 10.3935 10.3934 10.1895 10.5213 9.93863C10.6666 9.65342 10.6666 9.28005 10.6666 8.53331V3.46665C10.6666 2.71991 10.6666 2.34654 10.5213 2.06133C10.3934 1.81044 10.1895 1.60647 9.93857 1.47864C9.65336 1.33331 9.27999 1.33331 8.53325 1.33331H3.46659C2.71985 1.33331 2.34648 1.33331 2.06126 1.47864C1.81038 1.60647 1.60641 1.81044 1.47858 2.06133C1.33325 2.34654 1.33325 2.71991 1.33325 3.46665V8.53331C1.33325 9.28005 1.33325 9.65342 1.47858 9.93863C1.60641 10.1895 1.81038 10.3935 2.06126 10.5213C2.34648 10.6666 2.71985 10.6666 3.46659 10.6666Z"
                                          stroke="#344054"
                                          stroke-width="1.5"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_394_18059">
                                          <rect
                                            width="16"
                                            height="16"
                                            fill="white"
                                          />
                                        </clipPath>
                                      </defs>
                                    </svg>{" "}
                                    {t("duplicate")}
                                  </div>
                                  <div className="list-drop cursor-pointer"
                                  onClick={() => setShowModalDelete(assistant.uuid)}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      viewBox="0 0 16 16"
                                      fill="none"
                                    >
                                      <path
                                        d="M10.6667 3.99998V3.46665C10.6667 2.71991 10.6667 2.34654 10.5213 2.06133C10.3935 1.81044 10.1895 1.60647 9.93865 1.47864C9.65344 1.33331 9.28007 1.33331 8.53333 1.33331H7.46667C6.71993 1.33331 6.34656 1.33331 6.06135 1.47864C5.81046 1.60647 5.60649 1.81044 5.47866 2.06133C5.33333 2.34654 5.33333 2.71991 5.33333 3.46665V3.99998M2 3.99998H14M12.6667 3.99998V11.4666C12.6667 12.5868 12.6667 13.1468 12.4487 13.5746C12.2569 13.951 11.951 14.2569 11.5746 14.4487C11.1468 14.6666 10.5868 14.6666 9.46667 14.6666H6.53333C5.41323 14.6666 4.85318 14.6666 4.42535 14.4487C4.04903 14.2569 3.74307 13.951 3.55132 13.5746C3.33333 13.1468 3.33333 12.5868 3.33333 11.4666V3.99998"
                                        stroke="#F04438"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </svg>{" "}
                                    {t("delete")}
                                  </div>
                                </Dropdown.Menu>
                              </Dropdown>
                        </div>
                      </div>
                    </div>
                  )
              )
            )}
            {
              showModalDelete &&
              <DeleteAssistantModal
                show={showModalDelete}
                handleClose={handleCloseDelete}
                onClickDeletehandler={onClickDeletehandler}
                loading={loading}
              />
            }
            {totallength > 10 && buildBy === "me" &&(
              <CustomPagination handlePageChange={setPage} between={4} totalLength={totallength} totalPages={totalPages} />
            )}
          </Tab>

          {/* {pagination && totallength >= 10 && (
                <div className="pagnation-table d-flex align-items-center justify-content-between">
                  <button className="table-btn">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M15.8332 9.99935H4.1665M4.1665 9.99935L9.99984 15.8327M4.1665 9.99935L9.99984 4.16602"
                        stroke="#344054"
                        stroke-width="1.66667"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>{" "}
                    Previous
                  </button>
                  <PaginationControl
                    page={parseInt(page)}
                    between={1}
                    total={totallength}
                    limit={limit}
                    changePage={(page) => {
                      setPage(page);
                      // debugger;
                      // if (onPageChange) onPageChange(page);
                    }}
                    next
                    last
                    ellipsis={1}
                  />
                  <button className="table-btn">
                    Next{" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M4.16675 9.99935H15.8334M15.8334 9.99935L10.0001 4.16602M15.8334 9.99935L10.0001 15.8327"
                        stroke="#344054"
                        stroke-width="1.66667"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                </div>
              )} */}
          <Tab
            onClick={() => setBuildBy("others")}
            eventKey="Builtbyothers"
            title={t("builtByOthers")}
          >
            <div className="filter-drop">
              {/* <select
                    onChange={handleSelect}
                    className="form-select"
                    aria-label="Default select example"
                  >
                    <option eventKey="Reset" value="Reset">
                      {t("published")} + {t("drafts")}
                    </option>
                    <option eventKey="published" value="published">
                      {t("published")}
                    </option>
                    <option eventKey="unpublished" value="unpublished">
                      {t("drafts")}
                    </option>
                  </select> */}
                  <DropdownButton
                    align="end"
                    title="Sort By"
                    id="dropdown-menu-align-end"
                    className="custom-dropdown"
                    show={isDropdownOpen}
                    onToggle={handleToggle}
                  >
                    <div className="sortoption" onClick={(e) => e.stopPropagation()}>
                      <div className="d-flex justify-content-end align-items-center">
                        {/* <div className="sorthead">Sort By</div> */}
                        <div className="close cursor-pointer">
                            <svg
                             onClick={()=>setIsDropdownOpen(false)}
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width="24"
                              height="24"
                              fill="rgba(0,0,0,1)"
                            >
                              <path d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z"></path>
                            </svg>
                          </div>
                        
                      </div>
                      <div className="sort-options">
                        <div className="d-flex gap-3 align-items-center">
                          <select
                            onChange={(event)=>setSortBy(event.target.value)}
                            className="form-select"
                            aria-label="Default select example"
                          >
                           
                            <option  value="publishedOn">
                            Modified Date
                            </option>
                            <option  value="title">
                            Title
                            </option>

                          </select>
                          <select
                            //className="form-select asbtn dsc"
                            className={`form-select asbtn ${sortOrder === 'desc' ? 'dsc' : 'asc'}`}
                            aria-label="Default select example"
                            onChange={(event)=>setSortOrder(event.target.value)}
                            value={sortOrder}
                          >
                            <option value="asc">Ascending</option>
                            <option value="desc">Descending</option>
                          </select>
                         
                        </div>
                        
                        <div className="mt-3 d-flex justify-content-end">
                          <button className="default-btn" onClick={handleSortSelect}>Apply</button>
                        </div>
                      </div>
                    </div>
                    
              
              </DropdownButton> 
            </div>
            {/* <div className="filter-drop">
                <select className="form-select" aria-label="Default select example">
                  <option value="txtDeployedDrafts">Deployed + Drafts</option>
                 
                </select>
                </div> */}

            {assistants?.length <= 0 ? (
              <NotFoundComponent message={t("noAssistantFound")} />
            ) : (
              assistants?.map((assistant) => (
                <div className="pdf-wrapper">
                  <div className="pdf-list-assitant" key={assistant._id}>
                    <div className="pdf-icon-box">
                      {assistant.thumbnailUrl &&
                        typeof assistant.thumbnailUrl === "string" ? (
                        <img
                          style={{
                            width: "56px",
                            height: "56px",
                            borderRadius: "100%",
                          }}
                          src={assistant.thumbnailUrl}
                          alt=""
                        />
                      ) : (
                        <svg
                          width="56"
                          height="56"
                          viewBox="0 0 56 56"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect width="56" height="56" rx="28" fill="#F2F4F7" />
                          <g opacity="0.08">
                            <rect
                              x="0.375"
                              y="0.375"
                              width="55.25"
                              height="55.25"
                              rx="27.625"
                              stroke="#101828"
                              strokeWidth="0.75"
                            />
                          </g>
                          <path
                            d="M30.6667 15.026V20.5334C30.6667 21.2802 30.6667 21.6535 30.812 21.9388C30.9399 22.1896 31.1438 22.3936 31.3947 22.5214C31.6799 22.6668 32.0533 22.6668 32.8 22.6668H38.3074M30.6667 34.6667H22.6667M33.3334 29.3333H22.6667M38.6667 25.3176V34.9333C38.6667 37.1735 38.6667 38.2937 38.2307 39.1493C37.8472 39.9019 37.2353 40.5139 36.4827 40.8974C35.627 41.3333 34.5069 41.3333 32.2667 41.3333H23.7334C21.4932 41.3333 20.3731 41.3333 19.5174 40.8974C18.7648 40.5139 18.1528 39.9019 17.7693 39.1493C17.3334 38.2937 17.3334 37.1735 17.3334 34.9333V21.0667C17.3334 18.8265 17.3334 17.7064 17.7693 16.8507C18.1528 16.0981 18.7648 15.4861 19.5174 15.1026C20.3731 14.6667 21.4932 14.6667 23.7334 14.6667H28.0157C28.9941 14.6667 29.4833 14.6667 29.9436 14.7772C30.3518 14.8752 30.742 15.0368 31.0998 15.2561C31.5035 15.5035 31.8494 15.8494 32.5412 16.5412L36.7922 20.7922C37.484 21.484 37.8299 21.8299 38.0773 22.2335C38.2966 22.5914 38.4582 22.9816 38.5562 23.3897C38.6667 23.8501 38.6667 24.3393 38.6667 25.3176Z"
                            stroke="#475467"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      )}
                    </div>
                    <div className="pdf-info-box">
                      <div className="d-flex pdf-title-ass">
                        <div className="pdf-name">{assistant.title}</div>
                        <ul className="pills-pdf mb-0">
                          <li className="ed">
                            {assistant.count} {t("users")}
                          </li>
                          {assistant.isPublish ? (
                            <li className="poubli">{t("published")}</li>
                          ) : (
                            <li className="unpubli">{t("unpublished")}</li>
                          )}
                          {/* <li className="cop">4 copies</li> */}
                        </ul>
                      </div>
                      <p className="mb-0 assist-desc">
                        {assistant.description}
                      </p>
                    </div>
                    <div className="btn-pdf-wrapper">
                      {manageRoles.some((role) =>
                        (assistant.rolecode || "").split(",").includes(role)
                      ) && (
                          <>
                            <button
                              type="submit"
                              className="custom-bt btn-primary"
                              onClick={() => handleEdit(assistant.uuid)}
                            >
                              {t("modify")}{" "}
                            </button>
                            <button
                              type="submit"
                              className="custom-bt btn-primary"
                              onClick={() =>
                                navigate(`/assignuser?uuid=${assistant?.uuid}`)
                              }
                            >
                              {t("assign")}
                            </button>
                          </>
                        )}
                      {assistant.rolecode !== null && (
                        <button
                          type="submit"
                          className="custom-bt btn-primary"
                          onClick={() =>
                            navigate(`/assistant/launch?uuid=${assistant.uuid}`)
                          }
                        >
                          {t("useIt")}{" "}
                        </button>
                      )}
                      <Dropdown className="customdropdown-btn">
                          <Dropdown.Toggle
                            variant="success"
                            id="dropdown-basic"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                            >
                              <path
                                d="M10.0001 10.8333C10.4603 10.8333 10.8334 10.4602 10.8334 9.99999C10.8334 9.53976 10.4603 9.16666 10.0001 9.16666C9.53984 9.16666 9.16675 9.53976 9.16675 9.99999C9.16675 10.4602 9.53984 10.8333 10.0001 10.8333Z"
                                stroke="#98A2B3"
                                stroke-width="1.66667"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M10.0001 4.99999C10.4603 4.99999 10.8334 4.6269 10.8334 4.16666C10.8334 3.70642 10.4603 3.33333 10.0001 3.33333C9.53984 3.33333 9.16675 3.70642 9.16675 4.16666C9.16675 4.6269 9.53984 4.99999 10.0001 4.99999Z"
                                stroke="#98A2B3"
                                stroke-width="1.66667"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M10.0001 16.6667C10.4603 16.6667 10.8334 16.2936 10.8334 15.8333C10.8334 15.3731 10.4603 15 10.0001 15C9.53984 15 9.16675 15.3731 9.16675 15.8333C9.16675 16.2936 9.53984 16.6667 10.0001 16.6667Z"
                                stroke="#98A2B3"
                                stroke-width="1.66667"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </Dropdown.Toggle>

                          <Dropdown.Menu>
                            <div className="list-drop cursor-pointer"
                            onClick={() => duplicate(assistant.uuid)}
                                  >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                              >
                                <g clip-path="url(#clip0_394_18059)">
                                  <path
                                    d="M5.33325 10.6666V12.5333C5.33325 13.28 5.33325 13.6534 5.47858 13.9386C5.60641 14.1895 5.81038 14.3935 6.06126 14.5213C6.34648 14.6666 6.71985 14.6666 7.46659 14.6666H12.5333C13.28 14.6666 13.6534 14.6666 13.9386 14.5213C14.1895 14.3935 14.3934 14.1895 14.5213 13.9386C14.6666 13.6534 14.6666 13.28 14.6666 12.5333V7.46665C14.6666 6.71991 14.6666 6.34654 14.5213 6.06133C14.3934 5.81044 14.1895 5.60647 13.9386 5.47864C13.6534 5.33331 13.28 5.33331 12.5333 5.33331H10.6666M3.46659 10.6666H8.53325C9.27999 10.6666 9.65336 10.6666 9.93857 10.5213C10.1895 10.3935 10.3934 10.1895 10.5213 9.93863C10.6666 9.65342 10.6666 9.28005 10.6666 8.53331V3.46665C10.6666 2.71991 10.6666 2.34654 10.5213 2.06133C10.3934 1.81044 10.1895 1.60647 9.93857 1.47864C9.65336 1.33331 9.27999 1.33331 8.53325 1.33331H3.46659C2.71985 1.33331 2.34648 1.33331 2.06126 1.47864C1.81038 1.60647 1.60641 1.81044 1.47858 2.06133C1.33325 2.34654 1.33325 2.71991 1.33325 3.46665V8.53331C1.33325 9.28005 1.33325 9.65342 1.47858 9.93863C1.60641 10.1895 1.81038 10.3935 2.06126 10.5213C2.34648 10.6666 2.71985 10.6666 3.46659 10.6666Z"
                                    stroke="#344054"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_394_18059">
                                    <rect width="16" height="16" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>{" "}
                              {t("duplicate")}
                            </div>
                            {/* <div className="list-drop">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                              >
                                <path
                                  d="M10.6667 3.99998V3.46665C10.6667 2.71991 10.6667 2.34654 10.5213 2.06133C10.3935 1.81044 10.1895 1.60647 9.93865 1.47864C9.65344 1.33331 9.28007 1.33331 8.53333 1.33331H7.46667C6.71993 1.33331 6.34656 1.33331 6.06135 1.47864C5.81046 1.60647 5.60649 1.81044 5.47866 2.06133C5.33333 2.34654 5.33333 2.71991 5.33333 3.46665V3.99998M2 3.99998H14M12.6667 3.99998V11.4666C12.6667 12.5868 12.6667 13.1468 12.4487 13.5746C12.2569 13.951 11.951 14.2569 11.5746 14.4487C11.1468 14.6666 10.5868 14.6666 9.46667 14.6666H6.53333C5.41323 14.6666 4.85318 14.6666 4.42535 14.4487C4.04903 14.2569 3.74307 13.951 3.55132 13.5746C3.33333 13.1468 3.33333 12.5868 3.33333 11.4666V3.99998"
                                  stroke="#F04438"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>{" "}
                              {t("delete")}
                            </div> */}
                          </Dropdown.Menu>
                        </Dropdown>
                    </div>
                  </div>
                </div>
              ))
            )}

            {totallength2 > 10 && buildBy === "others" && (
              <CustomPagination handlePageChange={setPage} between={4} totalLength={totallength2} totalPages={totalPages} />
            )}
          </Tab>
        </Tabs>
      </div>
    </>
  );
}